const GUID_PATTERN = /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i;

export function isValidGuid(value: string | null | undefined): value is string {
  return value !== null && value !== undefined && GUID_PATTERN.test(value);
}
